import styled from "styled-components"

export const Container = styled.div`
  padding: "0px";
  border-bottom: ${props =>
    !props.isFilter ? "1px solid rgba(255, 255, 255, 0.2)" : ""};
`

export const ContainerLink = styled.a`
  padding: 19px 0px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  justify-content: space-between;
  margin-top: 0;
  cursor: pointer;
`

export const InfoIcon = styled.img`
  width: 28px;
  height: 28px;
  vertical-align: middle;
  margin-top: 3px;
`

export const ArrowContainer = styled.div`
  margin-top: ${props => (props.logo ? 0 : "3px")};
  margin-right: 5px;
  max-height: 40px;
`

export const InfoName = styled.span`
  font-weight: 700;
  font-size: 1.5em;
  line-height: 34px;
  color: #fff;
  margin-left: 8px;
`

export const ArrowUp = styled.img`
  transition: all 0.2s ease;
  transform: ${props => (props.open ? "rotate(-90deg)" : "")};
  max-width: 40px;
  max-height: 40px;
`

export const ArrowDown = styled.img`
  transition: all 0.2s ease;
  transform: ${props => (props.open ? "rotate(90deg)" : "rotate(-90deg)")};
  max-width: 40px;
  max-height: 40px;
`

export const AccordionInfo = styled.div`
  font-weight: 500;
  font-size: 1.1em;
  color: #cccccc;
  width: 100%;
  padding-bottom: 21px;
  font-family: "Roboto";
  transition: all 1.2s ease;
  font-style: normal;
  display: ${props => (props.open ? "flex" : "none")};
  flex-direction: column;
  margin-top: ${props => (props.isFilter && !props.isTypeFilter ? "23px" : "")};
`

export const InfoContainer = styled.div`
  margin-top: 11px;
  display: flex;
`

export const InfoHeaderContainer = styled.div`
  margin-top: 0px;
  display: flex;
`

export const HeaderContainer = styled.div`
  cursor: pointer;
  border-radius: 0px;
  padding: 19px 0px;
  justify-content: space-between;
  width: 100%;
  border-bottom: ${props =>
    props.isFilter ? "1px solid rgba(255, 255, 255, 0.2)" : ""};
`
